exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** ./~/._core-js@2.4.1@core-js/library/modules/_wks-ext.js
 ** module id = 106
 ** module chunks = 0 1
 **/